import script from "./SocialHomepageInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialHomepageInput.vue?vue&type=script&setup=true&lang=js"

import "./SocialHomepageInput.vue?vue&type=style&index=0&id=35f7a8fe&scoped=true&lang=css"

import exportComponent from "/home/opt/gitlab-runner/web_influencer_admin_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35f7a8fe"]])

export default __exports__